import React, { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DEFAULT_TOUCHSPIN_DATA, TOUCHSPIN_DATA } from "../../../../Data/FormWidgets";
import { CommonTouchspin } from "../Common/CommonTouchspin";
import { RoundedTouchspins } from "../../../../Constant";

const RoundedTouchspin = () => {
  const initialValues = DEFAULT_TOUCHSPIN_DATA.map((data) => data.value);
  const [values, setValues] = useState(initialValues);
  const handleIncrement = (index: number) => {
    setValues((prevValues) => {
      return prevValues.map((value, i) => (i === index ? value + 1 : value));
    });
  };
  const handleDecrement = (index: number) => {
    setValues((prevValues) => {
      return prevValues.map((value, i) => (i === index && value > 0 ? value - 1 : value));
    });
  };
  return (
    <Col xl="12">
      <Card>
        <CommonCardHeader title={RoundedTouchspins}  span={TOUCHSPIN_DATA}/>
        <CardBody className="common-flex rounded-touchspin">
          {DEFAULT_TOUCHSPIN_DATA.map((data) => (
            <CommonTouchspin key={data.id} faAngle color={data.color} value={values[data.id - 1]} onIncrement={() => handleIncrement(data.id - 1)} onDecrement={() => handleDecrement(data.id - 1)} />
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default RoundedTouchspin;
